import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars,FaHamburger  } from "react-icons/fa";
import { useState, useEffect } from "react";
import styles from "../styles/home.module.scss";
import { Logo } from "../assets/index";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";



const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = () => setIsOpen(!isOpen);
    
      useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);
    return ( 
        <nav>
        <div className={styles["main-flex"]}>
            <div className={styles["first-flex"]}>
            <img src={Logo} alt="logo" className={styles["Header-logo"]}/>
                {/* <span className={styles["company-name"]}></span> */}
            </div>
            <div className={styles["items-flex"]} data-aos="fade-top" data-aos-duration="2000">
                <Link to="/Installation" className={styles["link"]}>Installation</Link>
                <Link to="/Features">Features</Link>
                <Link to="/Projects">projects</Link>
                <Link to="/Support">Support</Link>
            </div>
            <div className={styles["others-flex"]}>
                <Link to="https://github.com/DeveloperAspire/swifty-config" className={styles["link"]}>Github</Link>
                <Link to="#!">Contact Us</Link>
            </div>
            {isOpen && 
            <div className={styles["mobile-flex"]}>
            <button onClick={handleClick} className={styles["mobile-button"]}><FontAwesomeIcon icon={faClose}></FontAwesomeIcon></button> 
                <Link to="/Installation" className={styles["link"]}>Installation</Link>
                <Link to="/Features">Features</Link>
                <Link to="Projects">Projects</Link>
                <Link to="Support">Support</Link>
                <a to="https://github.com/DeveloperAspire/swifty-config">Github</a>
                <Link to="#!">Contact us</Link>
            </div>
            }
            <div className={styles["menu-btn"]}>
                <button onClick={handleClick} className={styles["button"]}><FaBars /></button> 
            </div>
        </div>
    </nav>
     );
}
 
export default NavBar;